<template>  
  <VUEModalCaricamentoDati v-if="CaricamentoDatiModuli"
                          :PathGif="require('@/assets/images/CaricamentoDatiGif.gif')"
                          :VisualizzaBottoneAnnulla="true"
                          :OggettoModalCaricamentoDati="OggettoModalCaricamentoDati"
                          @onClickAnnullaCaricamentoDati="OnClickAnnullaCaricamentoDati"/>
  <VUEModal v-if="PopupScalaAmpiezza" :Titolo="this.GetTraduzioneLabel('VUEAppContentRiassuntoAccelerometri','TKN_APP_CON_RIA_ACC_SCALA_GRAF',this.LinguaUtente)" Altezza="150px" Larghezza="500px" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
              @onClickChiudiModal="AnnullaPopupScalaAmpiezza()">
    <template v-slot:Body>      
      <div style="display: flex; flex-flow: column wrap; padding-left: 50px; padding-right: 50px">
        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-bottom: 5px;">
          <p style="width: 40%; margin: 0px; font-weight: bold; margin-right: 5px">{{ this.GetTraduzioneLabel('VUEAppContentRiassuntoAccelerometri','TKN_APP_CON_RIA_ACC_MINIMO',this.LinguaUtente) }} [{{ this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIGRAMMO',this.LinguaUtente) }}]</p>
          <input class="form-control" style="width:30%; text-align: right;" type="number" step="1" v-model="ObjPopupScalaAmpiezza.Min">
        </div>
        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-bottom: 5px;">
          <p style="width: 40%; margin: 0px; font-weight: bold; margin-right: 5px">{{ this.GetTraduzioneLabel('VUEAppContentRiassuntoAccelerometri','TKN_APP_CON_RIA_ACC_MASSIMO',this.LinguaUtente) }} [{{ this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIGRAMMO',this.LinguaUtente) }}]</p>
          <input class="form-control" style="width:30%; text-align: right;" type="number" step="1" v-model="ObjPopupScalaAmpiezza.Max">
        </div>
        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center;">
          <p style="width: 40%; margin: 0px; font-weight: bold; margin-right: 5px">{{ this.GetTraduzioneLabel('Generic','TKN_UNITA',this.LinguaUtente) }} [{{ this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIGRAMMO',this.LinguaUtente) }}]</p>
          <input class="form-control" style="width:30%; text-align: right;" type="number" step="1" v-model="ObjPopupScalaAmpiezza.Udm">
        </div>
      </div>
    </template>
    <template v-slot:Footer>
      <button type="button" class="btn btn-info" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="AnnullaPopupScalaAmpiezza()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ConfermaPopupScalaAmpiezza()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
  </VUEModal>
  <VUEModal v-if="PopupScalaRitardo" :Titolo="this.GetTraduzioneLabel('VUEAppContentRiassuntoAccelerometri','TKN_APP_CON_RIA_ACC_SCALA_GRAF',this.LinguaUtente)" Altezza="150px" Larghezza="500px" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
              @onClickChiudiModal="AnnullaPopupScalaRitardo()">
    <template v-slot:Body>      
      <div style="display: flex; flex-flow: column wrap; padding-left: 50px; padding-right: 50px">
        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-bottom: 5px;">
          <p style="width: 40%; margin: 0px; font-weight: bold; margin-right: 5px">{{ this.GetTraduzioneLabel('VUEAppContentRiassuntoAccelerometri','TKN_APP_CON_RIA_ACC_FONDOSCALA',this.LinguaUtente) }} [{{ this.GetTraduzioneLabel('UdmGenerali','TKS_MILLISECONDO',this.LinguaUtente) }}]</p>
          <input class="form-control" style="width:30%; text-align: right;" type="number" step="1" v-model="ObjPopupScalaRitardo.Max">
        </div>
        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center;">
          <p style="width: 40%; margin: 0px; font-weight: bold; margin-right: 5px">{{ this.GetTraduzioneLabel('Generic','TKN_UNITA',this.LinguaUtente) }} [{{ this.GetTraduzioneLabel('UdmGenerali','TKS_MILLISECONDO',this.LinguaUtente) }}]</p>
          <input class="form-control" style="width:30%; text-align: right;" type="number" step="1" v-model="ObjPopupScalaRitardo.Udm">
        </div>
      </div>
    </template>
    <template v-slot:Footer>
      <button type="button" class="btn btn-info" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="AnnullaPopupScalaRitardo()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ConfermaPopupScalaRitardo()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
  </VUEModal>
  <VUEModal v-if="PopupRitardo" :Titolo="this.GetTraduzioneLabel('VUEAppContentRiassuntoAccelerometri','TKN_APP_CON_RIA_ACC_SEL_RIT',this.LinguaUtente)" Altezza="70px" Larghezza="390px" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
              @onClickChiudiModal="AnnullaCambiaRitardo()">
    <template v-slot:Body>      
      <div style="display: flex; flex-flow: column wrap; padding-left: 50px; padding-right: 50px">
        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-bottom: 5px;">
          <p style="width: 40%; margin: 0px; font-weight: bold; margin-right: 5px">{{ this.GetTraduzioneLabel('VUEAppContentRiassuntoAccelerometri','TKN_APP_CON_RIA_ACC_NUOVO_RIT',this.LinguaUtente) }}:</p>
          <input class="form-control" style="width:30%; text-align: right;" type="number" step="1" v-model="TempRitardo">
        </div>
      </div>
    </template>
    <template v-slot:Footer>
      <button type="button" class="btn btn-info" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="AnnullaCambiaRitardo()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ConfermaCambiaRitardo()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
  </VUEModal>  
  
  <label style="font-weight: bold; color: white; position: absolute; top: -40px; font-size: 25px;" :style="{'left' : LarghezzaPagina * 0.4 + 'px'}">{{ Catena.Info.Descrizione }}</label>
  <div class="ZMRow" style="width: 100%; justify-content: space-between; padding : 10px;">
    <div class="ZMRow ZMCentered" style="width: 180px; justify-content: space-between">
      <input style="width: 25px; height: 25px; margin: 0px" v-model="Relativo" @change="Repaint++" type="checkbox" class="form-control"/>
      <label style="margin: 0px">{{ this.GetTraduzioneLabel('VUEAppContentRiassuntoAccelerometri','TKN_APP_CON_RIA_ACC_GRAF_REL',this.LinguaUtente) }}</label>
    </div>
    <div class="ZMRow ZMCentered" style="width: 350px; justify-content: space-between">
      <label style="margin: 0px">{{ this.GetTraduzioneLabel('VUEAppContentRiassuntoAccelerometri','TKN_APP_CON_RIA_ACC_FILTRA_RITARDO',this.LinguaUtente) + ': ' + Ritardo + ' ' + this.GetTraduzioneLabel('UdmGenerali','TKN_MG_CAMPIONE',this.LinguaUtente) }}</label>
      <button type="button" class="btn btn-info" style="font-weight:bold;width:100px" @click="CambiaRitardo()">{{ this.GetTraduzioneLabel('Generic','TKN_CAMBIA',this.LinguaUtente) }}</button>
    </div>
  </div>
  <div class="ZMRow" style="width: 100%;">
    <div class="ZMColumn" style="width: 62%;">
      <div class="ZMRow" style="width: 100%; justify-content: space-between; padding: 10px">
        <button type="button" class="btn btn-info" style="font-weight:bold;width:140px" @click="CambiaScalaGrafico()">{{ this.GetTraduzioneLabel('VUEAppContentRiassuntoAccelerometri','TKN_APP_CON_RIA_ACC_CHG_SCALA',this.LinguaUtente) }}</button>
        <button type="button" class="btn btn-info" style="font-weight:bold;width:120px" @click="CambiaTipoGrafico()">{{ GraficiAmpiezza ? 'Ritardo >>' : 'Ampiezza >>' }}</button>
      </div>
      <div v-if="GraficiAmpiezza" class="ZMRow" style="width:100%;" ref="DivGraphAmpiezza">
        <div class="ZMColumn" style="width: 33.3%">
          <div class="ZMSeparatoreScheda" style="margin: 0px; width: 100%;" :style="{'background-color' : ColoriPantone.Marrone }">       
            <text style="font-weight: bold;">{{ this.GetTraduzioneLabel('VUEAppContentRiassuntoAccelerometri','TKN_APP_CON_RIA_ACC_AMPIEZZA_X',this.LinguaUtente) }}</text>
          </div>
          <VUEComponenteGraficoAmpiezza v-if="Mostra"
                                        :WidthGrafico="GrandezzaCanvasAmpiezza.Width" 
                                        :HeightGrafico="GrandezzaCanvasAmpiezza.Height"
                                        :Dati="ObjGraficiAmpiezza.ObjGraficoX"
                                        :RepaintDeep="RepaintDeep"
                                        :Repaint="Repaint"/>
        </div>
        <div class="ZMColumn" style="width: 33.3%">
          <div class="ZMSeparatoreScheda" style="margin: 0px; width: 100%;" :style="{'background-color' : ColoriPantone.Marrone }">       
            <text style="font-weight: bold;">{{ this.GetTraduzioneLabel('VUEAppContentRiassuntoAccelerometri','TKN_APP_CON_RIA_ACC_AMPIEZZA_Y',this.LinguaUtente) }}</text>
          </div>       
          <VUEComponenteGraficoAmpiezza v-if="Mostra"
                                        :WidthGrafico="GrandezzaCanvasAmpiezza.Width" 
                                        :HeightGrafico="GrandezzaCanvasAmpiezza.Height"
                                        :Dati="ObjGraficiAmpiezza.ObjGraficoY"
                                        :RepaintDeep="RepaintDeep"
                                        :Repaint="Repaint"/>
        </div>
        <div class="ZMColumn" style="width: 33.3%">
          <div class="ZMSeparatoreScheda" style="margin: 0px; width: 100%;" :style="{'background-color' : ColoriPantone.Marrone }">       
            <text style="font-weight: bold;">{{ this.GetTraduzioneLabel('VUEAppContentRiassuntoAccelerometri','TKN_APP_CON_RIA_ACC_AMPIEZZA_Z',this.LinguaUtente) }}</text>
          </div>
          <VUEComponenteGraficoAmpiezza v-if="Mostra"
                                        :WidthGrafico="GrandezzaCanvasAmpiezza.Width" 
                                        :HeightGrafico="GrandezzaCanvasAmpiezza.Height"
                                        :Dati="ObjGraficiAmpiezza.ObjGraficoZ"
                                        :RepaintDeep="RepaintDeep"
                                        :Repaint="Repaint"/>
        </div>
      </div>

      <div v-else class="ZMRow" style="width:100%;" ref="DivGraphAmpiezza">
        <div class="ZMColumn" style="width: 33.3%;">
          <div class="ZMSeparatoreScheda" style="margin: 0px; width: 100%;" :style="{'background-color' : ColoriPantone.Marrone }">       
            <text style="font-weight: bold;">{{ this.GetTraduzioneLabel('VUEAppContentRiassuntoAccelerometri','TKN_APP_CON_RIA_ACC_RITARDO_X',this.LinguaUtente) }}</text>
          </div>
          <VUEComponenteGraficoRitardo  v-if="Mostra"
                                        :WidthGrafico="GrandezzaCanvasAmpiezza.Width" 
                                        :HeightGrafico="GrandezzaCanvasAmpiezza.Height"
                                        :Dati="ObjGraficiRitardo.ObjGraficoX"
                                        :RepaintDeep="RepaintDeep"
                                        :Repaint="Repaint"
                                        :RitardoRelativo="Relativo"
                                        :MinIstante="MinIstante"/>
        </div>
        <div class="ZMColumn"  style="width: 33.3%;">
          <div class="ZMSeparatoreScheda" style="margin: 0px; width: 100%;" :style="{'background-color' : ColoriPantone.Marrone }">       
            <text style="font-weight: bold;">{{ this.GetTraduzioneLabel('VUEAppContentRiassuntoAccelerometri','TKN_APP_CON_RIA_ACC_RITARDO_Y',this.LinguaUtente) }}</text>
          </div>       
          <VUEComponenteGraficoRitardo  v-if="Mostra"
                                        :WidthGrafico="GrandezzaCanvasAmpiezza.Width" 
                                        :HeightGrafico="GrandezzaCanvasAmpiezza.Height"
                                        :Dati="ObjGraficiRitardo.ObjGraficoY"
                                        :RepaintDeep="RepaintDeep"
                                        :Repaint="Repaint"
                                        :RitardoRelativo="Relativo"
                                        :MinIstante="MinIstante"/>
        </div>
        <div class="ZMColumn" style="width: 33.3%">
          <div class="ZMSeparatoreScheda" style="margin: 0px; width: 100%;" :style="{'background-color' : ColoriPantone.Marrone }">       
            <text style="font-weight: bold;">{{ this.GetTraduzioneLabel('VUEAppContentRiassuntoAccelerometri','TKN_APP_CON_RIA_ACC_RITARDO_Z',this.LinguaUtente) }}</text>
          </div>
          <VUEComponenteGraficoRitardo  v-if="Mostra"
                                        :WidthGrafico="GrandezzaCanvasAmpiezza.Width"
                                        :HeightGrafico="GrandezzaCanvasAmpiezza.Height"
                                        :Dati="ObjGraficiRitardo.ObjGraficoZ"
                                        :RepaintDeep="RepaintDeep"
                                        :Repaint="Repaint"
                                        :RitardoRelativo="Relativo"
                                        :MinIstante="MinIstante"/>
        </div>
      </div>
    </div>
    <div class="ZMColumn" style="width: 38%;">
      <div style="width: 100%; padding: 10px;">
        <div class="ZMRow" style="width: 100%;">
          <!-- <div class="ZMColumn" style="width: 50%;">
            <div style="width: 100%; display: flex">
              <label style="margin: 0px; font-weight: bold; margin-right: 5px">Cliente:</label>
              <label style="margin: 0px">{{ Catena.Info.Cliente }}</label>
            </div>
          </div> -->
          <div class="ZMColumn" style="width: 50%;">
            <div style="width: 100%; display: flex">
              <label style="margin: 0px; font-weight: bold; margin-right: 5px">{{ this.GetTraduzioneLabel('Generic','TKN_SITO',this.LinguaUtente) }}: </label>
              <label style="margin: 0px">{{ Catena.Info.NomeSito }}</label>
            </div>
          </div>
        </div>
        <div class="ZMRow" style="width: 100%;">
          <div style="width: 50%; display: flex;">
            <div style="width: 100%; display: flex">
              <label style="margin: 0px; font-weight: bold; margin-right: 5px">{{ this.GetTraduzioneLabel('Generic','TKN_PROGETTO_ESTESO',this.LinguaUtente) }}: </label>
              <label style="margin: 0px">{{ Catena.Info.Progetto }}</label>
            </div>
          </div>
          <div style="width: 50%; display: flex;">
            <div style="width: 100%; display: flex">
              <label style="margin: 0px; font-weight: bold; margin-right: 5px">{{ this.GetTraduzioneLabel('Generic','TKN_INT_MONITORAGGIO',this.LinguaUtente) }}: </label>
              <label style="margin: 0px">{{ Catena.Info.IntervalloMonitoraggio }}</label>
            </div>
          </div>
        </div>
        <div class="ZMRow" style="width: 100%;">
          <div style="width: 50%; display: flex;">
            <div style="width: 100%; display: flex">
              <label style="margin: 0px; font-weight: bold; margin-right: 5px">{{ this.GetTraduzioneLabel('Generic','TKN_DATA_INSTALLAZIONE',this.LinguaUtente) }}: </label>
              <label style="margin: 0px">{{ Catena.Info.DataInstallazione }}</label>
            </div>
          </div>
          <div style="width: 50%; display: flex;">
            <div style="width: 100%; display: flex">
              <label style="margin: 0px; font-weight: bold; margin-right: 5px">{{ this.GetTraduzioneLabel('Generic','TKN_DATA_CALIBRAZIONE',this.LinguaUtente) }}: </label>
              <label style="margin: 0px">{{ Catena.Info.DataCalibrazione }}</label>
            </div>
          </div>
        </div>        
        <div class="ZMRow" style="width: 100%;">
          <label style="width: 60px; margin:0px; font-weight: bold; margin-right: 5px">{{ this.GetTraduzioneLabel('Generic','TKN_NOTE',this.LinguaUtente) }}: </label>
          <label style="height: 40px; width: calc(100% - 60px)">{{ Catena.Info.Note }}</label>
        </div>
      </div>      
      <div class="ZMRow" style="width: 100%;" ref="DivIncidenza">
        <div class="ZMRow" style="width: 100%;">
          <div class="ZMSeparatoreScheda" style="margin: 0px; width: 100%;" :style="{'background-color' : ColoriPantone.Marrone }">       
            <text style="font-weight: bold;">{{ this.GetTraduzioneLabel('VUEAppContentRiassuntoAccelerometri','TKN_APP_CON_RIA_ACC_INC_TEMPO_X',this.LinguaUtente) }}</text>
          </div>
          <VUEComponenteGraficoIncidenza  v-if="Mostra"
                                          :WidthGrafico="GrandezzaCanvasIncidenza.Width" 
                                          :HeightGrafico="GrandezzaCanvasIncidenza.Height"
                                          :Dati="ObjGraficiIncidenza.ObjGraficoX"
                                          :RepaintDeep="RepaintDeep"
                                          :Repaint="Repaint"/>
        </div>
        <div class="ZMRow" style="width: 100%" ref="DivIncidenza">
          <div class="ZMSeparatoreScheda" style="margin: 0px; width: 100%;" :style="{'background-color' : ColoriPantone.Marrone }">       
            <text style="font-weight: bold;">{{ this.GetTraduzioneLabel('VUEAppContentRiassuntoAccelerometri','TKN_APP_CON_RIA_ACC_INC_TEMPO_Y',this.LinguaUtente) }}</text>
          </div>
          <VUEComponenteGraficoIncidenza  v-if="Mostra"
                                          :WidthGrafico="GrandezzaCanvasIncidenza.Width" 
                                          :HeightGrafico="GrandezzaCanvasIncidenza.Height"
                                          :Dati="ObjGraficiIncidenza.ObjGraficoY"
                                          :RepaintDeep="RepaintDeep"
                                          :Repaint="Repaint"/>
        </div>
        <div class="ZMRow" style="width: 100%" ref="DivIncidenza">
          <div class="ZMSeparatoreScheda" style="margin: 0px; width: 100%;" :style="{'background-color' : ColoriPantone.Marrone }">       
            <text style="font-weight: bold;">{{ this.GetTraduzioneLabel('VUEAppContentRiassuntoAccelerometri','TKN_APP_CON_RIA_ACC_INC_TEMPO_Z',this.LinguaUtente) }}</text>
          </div>
          <VUEComponenteGraficoIncidenza  v-if="Mostra"
                                          :WidthGrafico="GrandezzaCanvasIncidenza.Width" 
                                          :HeightGrafico="GrandezzaCanvasIncidenza.Height"
                                          :Dati="ObjGraficiIncidenza.ObjGraficoZ"
                                          :RepaintDeep="RepaintDeep"
                                          :Repaint="Repaint"/>
        </div>
      </div>      
    </div>
  </div>

</template>

<script>
import VUEComponenteGraficoAmpiezza from '../../../src/components/Slots/VUEComponenteGraficoAmpiezza.vue'
import VUEComponenteGraficoRitardo from '../../../src/components/Slots/VUEComponenteGraficoRitardo.vue'
import VUEComponenteGraficoIncidenza from '../../../src/components/Slots/VUEComponenteGraficoIncidenza.vue'
import MixInsGestioneTraduzioni from '@/utils/MixInsGestioneTraduzioni.js';
import VUEModalCaricamentoDati from '@/utils/VUEModalCaricamentoDati.vue'
import { COLORI_PANTONE, TIPI_UDM_X, SystemInformation } from '@/SystemInformation'
import VUEModal from '@/utils/VUEModal.vue'
import { TZGenericFunct } from '@/utils/ZGenericFunct'
import { TZMathFunct } from '@/utils/ZMathFunct'
import { TSchedaGenerica } from '@/utils/ZSchedaGenerica'
import { TZDateFunct } from '@/utils/ZDateFunct'

const TIPI_ASSI = {
                    Tutte : -1,
                    X     : 0,
                    Y     : 1,
                    Z     : 2
                  }

class TObjGrafico
{
  constructor()
  {
    this.AsseX = {Min : 0, Max : 10, Udm : 1}
    this.AsseY = {Min : 999, Max : -999, Udm : 10, Inverted : false}
    this.Generale = {}
  }
}

class TObjGruppoGrafici
{
  constructor()
  {
    this.ObjGraficoX = new TObjGrafico()
    this.ObjGraficoY = new TObjGrafico()
    this.ObjGraficoZ = new TObjGrafico()
  }
}

export default 
{
  props : ['AltezzaPagina', 'LarghezzaPagina'],
  mixins: [ MixInsGestioneTraduzioni ],
  data()
  {
   return {
            Mostra                      : false,
            DatiURL                     : {},
            Catena                      : {},
            Evento                      : {},
            CaricamentoDatiModuli       : false,
            ColoriPantone               : COLORI_PANTONE,
            OggettoModalCaricamentoDati : {},
            GrandezzaCanvasAmpiezza     : {
                                            Width  : 0,
                                            Height : 0
                                          },
            GrandezzaCanvasIncidenza    : {
                                            Width  : 0,
                                            Height : 0
                                          },
            ObjGraficiAmpiezza          : {},
            ObjGraficiIncidenza         : {},
            GraficiAmpiezza             : true,
            PopupRitardo                : false,
            Ritardo                     : 20,
            TempRitardo                 : 20,
            TipiUdmX                    : TIPI_UDM_X,
            ObjGrafico                  : {},
            Repaint                     : 0,
            RepaintDeep                 : 0,
            PopupScalaAmpiezza          : false,
            PopupScalaRitardo           : false,
            PopupLegenda                : false,
            PopupSintetici              : false,
            ArrayLegenda                : [],
            ObjPopupScalaAmpiezza       : {},
            ObjPopupScalaRitardo        : {},
            TipiAssi                    : TIPI_ASSI,
            PrimoCampione               : {X: 0, Y: 0, Z: 0},
            TitoloFrame                 : '',
            Relativo                    : true,
            LinguaUtente                : SystemInformation.UserInformation.Lingua,
            MinIstante                  : 0
          }
  },

  emits : [],
  components:
  {
    VUEModal,
    VUEModalCaricamentoDati,
    VUEComponenteGraficoAmpiezza,
    VUEComponenteGraficoIncidenza,
    VUEComponenteGraficoRitardo
  },

  methods :
  {
    CambiaScalaGrafico()
    {
      this.ObjPopupScalaAmpiezza.Min = this.ObjGraficiAmpiezza.ObjGraficoX.AsseX.Min
      this.ObjPopupScalaAmpiezza.Max = this.ObjGraficiAmpiezza.ObjGraficoX.AsseX.Max
      this.ObjPopupScalaAmpiezza.Udm = this.ObjGraficiAmpiezza.ObjGraficoX.AsseX.Udm
      this.ObjPopupScalaRitardo.Max = this.ObjGraficiRitardo.ObjGraficoX.AsseX.Max
      this.ObjPopupScalaRitardo.Udm = this.ObjGraficiRitardo.ObjGraficoX.AsseX.Udm
      this.GraficiAmpiezza ? this.PopupScalaAmpiezza = true : this.PopupScalaRitardo = true
    },

    AnnullaPopupScalaAmpiezza()
    {
      this.PopupScalaAmpiezza = false
      this.ObjPopupScalaAmpiezza = {}
    },

    ConfermaPopupScalaAmpiezza()
    {
      this.ObjGraficiAmpiezza.ObjGraficoX.AsseX.Min = this.ObjPopupScalaAmpiezza.Min
      this.ObjGraficiAmpiezza.ObjGraficoX.AsseX.Max = this.ObjPopupScalaAmpiezza.Max
      this.ObjGraficiAmpiezza.ObjGraficoX.AsseX.Udm = this.ObjPopupScalaAmpiezza.Udm
      
      this.ObjGraficiAmpiezza.ObjGraficoY.AsseX.Min = this.ObjPopupScalaAmpiezza.Min
      this.ObjGraficiAmpiezza.ObjGraficoY.AsseX.Max = this.ObjPopupScalaAmpiezza.Max
      this.ObjGraficiAmpiezza.ObjGraficoY.AsseX.Udm = this.ObjPopupScalaAmpiezza.Udm
      
      this.ObjGraficiAmpiezza.ObjGraficoZ.AsseX.Min = this.ObjPopupScalaAmpiezza.Min
      this.ObjGraficiAmpiezza.ObjGraficoZ.AsseX.Max = this.ObjPopupScalaAmpiezza.Max
      this.ObjGraficiAmpiezza.ObjGraficoZ.AsseX.Udm = this.ObjPopupScalaAmpiezza.Udm
      this.Repaint++
      this.PopupScalaAmpiezza = false
      this.ObjPopupScalaAmpiezza = {}
    },

    AnnullaPopupScalaRitardo()
    {
      this.PopupScalaRitardo = false
      this.ObjPopupScalaRitardo = {}
    },

    ConfermaPopupScalaRitardo()
    {
      this.ObjGraficiRitardo.ObjGraficoX.AsseX.Max = this.ObjPopupScalaRitardo.Max
      this.ObjGraficiRitardo.ObjGraficoX.AsseX.Udm = this.ObjPopupScalaRitardo.Udm
      this.Repaint++
      this.PopupScalaRitardo = false
      this.ObjPopupScalaRitardo = {}
    },

    OnClickAnnullaCaricamentoDati()
    {

    },

    CambiaTipoGrafico()
    {
      this.GraficiAmpiezza = !this.GraficiAmpiezza
      this.RepaintDeep++
    },

    CambiaRitardo()
    {
      this.PopupRitardo = true
    },

    ConfermaCambiaRitardo()
    {
      this.Ritardo = this.TempRitardo
      this.CaricaDati()
      this.PopupRitardo = false
    },

    AnnullaCambiaRitardo()
    {
      this.PopupRitardo = false
      this.TempRitardo = this.Ritardo
    },

    CaricaDati()
    { 
      let MaxData = 0
      let MinData = -1
      let MaxIstante = 0
      let MinIstante = -1
      // this.GetPorzioniDiDate()
      // this.DownloadDatiAcquisitiModuli()
      let AsseX = {}
      AsseX.Min = 0
      AsseX.Max = 10
      AsseX.Udm = 1

      this.CaricamentoDatiModuli = true
      let Self = this
      let ParametriQuery      = {}
      ParametriQuery.Data     = TZDateFunct.FormatDateTime('yyyy-mm-dd hh:nn:ss', new Date(parseInt(this.DatiURL.Data)))
      ParametriQuery.Stacking = this.DatiURL.Stacking
      ParametriQuery.IdSito   = this.DatiURL.Sito
      ParametriQuery.IdCatena = this.DatiURL.Catena
      this.Mostra = false
      SystemInformation.AdvQuery.ExecuteExternalScript('ExtraCampioniSuperamentiSoglia', ParametriQuery, function(Answer) 
      {
        Self.Evento.MsEnd  = 0
        Self.Evento.Moduli = []
        Self.ObjGraficiIncidenza.ObjGraficoX.Generale.Punti = []
        Self.ObjGraficiIncidenza.ObjGraficoY.Generale.Punti = []
        Self.ObjGraficiIncidenza.ObjGraficoZ.Generale.Punti = []
        Answer.QueryData.forEach((element) => 
        {
          let DataMS = Date.parse(element.DataEffettiva) + element.Millisecondi
          if (MaxData < (DataMS + (element.Campioni.length * element.PeriodoCampionamento)))
            MaxData = DataMS + (element.Campioni.length * element.PeriodoCampionamento)
          if (MinData == -1)
            MinData = DataMS
          else
            MinData = Math.min(MinData, DataMS)
          let index = Self.Evento.Moduli.findIndex((voce) => {return voce.Modulo == element.Modulo}) 
          if (index == -1)
          {
            let ObjCampione = {}
            ObjCampione.Modulo = element.Modulo
            let InfoModulo = Self.Catena.Moduli.find((Modulo) => {return Modulo.MODULO == element.Modulo})
            ObjCampione.Profondita = InfoModulo.PROFONDITA / 100
            ObjCampione.MinX = 99999
            ObjCampione.MaxX = -99999
            ObjCampione.MinY = 99999
            ObjCampione.MaxY = -99999
            ObjCampione.MinZ = 99999
            ObjCampione.MaxZ = -99999
            ObjCampione.IstanteX = null
            ObjCampione.IstanteY = null
            ObjCampione.IstanteZ = null
            //Mettere altre proprietà
            Self.Evento.Moduli.push(ObjCampione)
            index = Self.Evento.Moduli.length - 1
          }
          let Voce = Self.Evento.Moduli[index]
          let FirstValue = {}
          let SetPrec = {X: 0, Y: 0, Z: 0}
          let Started = {X : false, Y : false, Z : false}
          if (element.Campioni.length > 0)
          {
            FirstValue = element.Campioni[0]
          }
          Self.ObjGraficiRitardo.ObjGraficoX.Generale.Istante = null
          Self.ObjGraficiRitardo.ObjGraficoY.Generale.Istante = null
          Self.ObjGraficiRitardo.ObjGraficoZ.Generale.Istante = null
          for (let i = 0; i < element.Campioni.length; i++)
          {
            let SingleCampione = element.Campioni[i]
            let X = Math.round((SingleCampione.X - FirstValue.X) * 10) / 10
            let Y = Math.round((SingleCampione.Y - FirstValue.Y) * 10) / 10
            let Z = Math.round((SingleCampione.Z - FirstValue.Z) * 10) / 10
            if (Voce.MinX > X)
              Voce.MinX = X
            if (Voce.MaxX < X)
              Voce.MaxX = X
            if (Voce.MinY > Y)
              Voce.MinY = Y
            if (Voce.MaxY < Y)
              Voce.MaxY = Y
            if (Voce.MinZ > Z)
              Voce.MinZ = Z
            if (Voce.MaxZ < Z)
              Voce.MaxZ = Z
            let Istante = DataMS + (i * element.PeriodoCampionamento) - MinData
             
            if (!Started.X && (Math.abs(X - SetPrec.X) >= Self.Ritardo))
            {
              Started.X = true
              MaxIstante = Math.max(Istante, MaxIstante)
              // if (Self.ObjGraficiRitardo.ObjGraficoX.Generale.Istante == null || 
              //     Self.ObjGraficiRitardo.ObjGraficoX.Generale.Istante > DataMS + (i * element.PeriodoCampionamento) - MinData)
              if (Voce.IstanteX == null || 
                  Voce.IstanteX > Istante)
              {
                Voce.IstanteX = Istante
                // Self.ObjGraficiIncidenza.ObjGraficoX.Generale.Punti.push(DataMS + (i * element.PeriodoCampionamento))
              }
              if (MinIstante == -1)
                MinIstante = Istante
              else
                MinIstante = Math.min(MinIstante, Istante)
            }
            if (!Started.Y && (Math.abs(Y - SetPrec.Y) >= Self.Ritardo))
            {
              Started.Y = true
              MaxIstante = Math.max(Istante, MaxIstante)
              
              // if (Self.ObjGraficiRitardo.ObjGraficoY.Generale.Istante == null || 
              //     Self.ObjGraficiRitardo.ObjGraficoY.Generale.Istante > DataMS + (i * element.PeriodoCampionamento) - MinData)
              if (Voce.IstanteY == null || 
                  Voce.IstanteY > Istante)
              {                
                Voce.IstanteY = Istante
                // Self.ObjGraficiIncidenza.ObjGraficoY.Generale.Punti.push(DataMS + (i * element.PeriodoCampionamento))
              }
              if (MinIstante < 0)
                MinIstante = Istante
              else
                MinIstante = Math.min(MinIstante, Istante)
            }
            if (!Started.Z && (Math.abs(Z - SetPrec.Z) >= Self.Ritardo))
            {
              Started.Z = true
              MaxIstante = Math.max(Istante, MaxIstante)
              
              // if (Self.ObjGraficiRitardo.ObjGraficoZ.Generale.Istante == null || 
              //     Self.ObjGraficiRitardo.ObjGraficoZ.Generale.Istante > DataMS + (i * element.PeriodoCampionamento) - MinData)
              if (Voce.IstanteZ == null || 
                  Voce.IstanteZ > Istante)
              {
                Voce.IstanteZ = Istante
                // Self.ObjGraficiIncidenza.ObjGraficoZ.Generale.Punti.push(DataMS + (i * element.PeriodoCampionamento))
              }
              if (MinIstante == -1)
                MinIstante = Istante
              else
                MinIstante = Math.min(MinIstante, Istante)
            }
            SetPrec = {X: X, Y: Y, Z: Z}
          }
        })

        Self.MinIstante = MinIstante

        let MaxX = 0
        let MaxY = 0
        let MaxZ = 0
        Self.Evento.Moduli.forEach((element) =>
        {
          MaxX = Math.max(Math.abs(element.MaxX - element.MinX), MaxX)
          MaxY = Math.max(Math.abs(element.MaxY - element.MinY), MaxY)
          MaxZ = Math.max(Math.abs(element.MaxZ - element.MinZ), MaxZ)
          element.MaxXAmpiezza = MaxX / 10
          element.MaxYAmpiezza = MaxY / 10
          element.MaxZAmpiezza = MaxZ / 10
        })
        let Max = Math.max(MaxX, MaxY, MaxZ)
        Max = TZMathFunct.GetMultiplo(Max, 10, 'Eccesso')
        let Min = Max * -1
        let Udm = Max / 2

        if (Max == 0)
        {
          Max = 10
          Max = -10
          Udm = 2
        }

        let AsseXAmpiezza = {}
        AsseXAmpiezza.Min = Min
        AsseXAmpiezza.Max = Max
        AsseXAmpiezza.Udm = Udm
        
        let AsseXRitardo = {}
        if (MaxIstante == 0)
          MaxIstante = 2000
        AsseXRitardo.Min = 0
        // AsseXRitardo.Max = TZMathFunct.GetMultiplo(MaxData - MinData, 10 , 'Eccesso')
        // AsseXRitardo.Udm = TZMathFunct.GetMultiplo(MaxIstante / 5, 10, 'Eccesso')
        AsseXRitardo.Max = TZMathFunct.GetMultiplo(MaxIstante, 100 , 'Eccesso')
        AsseXRitardo.Udm = TZMathFunct.GetMultiplo(MaxIstante / 5, 50, 'Eccesso')

        let AsseXIncidenza = {}
        AsseXIncidenza.Min = 0
        AsseXIncidenza.Max = MaxData - MinData
        AsseXIncidenza.Udm = AsseXIncidenza.Max / 10
        // Self.Evento.MsEnd = Math.max(Evento.MsEnd, (new Date(ObjCampione.DataEffettiva).valueOf() + (ObjCampione.Campioni.length * element.PeriodoCampionamento)))

        Self.ObjGraficiAmpiezza.ObjGraficoX.AsseX = AsseXAmpiezza        
        Self.ObjGraficiAmpiezza.ObjGraficoY.AsseX = AsseXAmpiezza
        Self.ObjGraficiAmpiezza.ObjGraficoZ.AsseX = AsseXAmpiezza
        
        Self.ObjGraficiRitardo.ObjGraficoX.AsseX = AsseXRitardo        
        Self.ObjGraficiRitardo.ObjGraficoY.AsseX = AsseXRitardo
        Self.ObjGraficiRitardo.ObjGraficoZ.AsseX = AsseXRitardo
        
        Self.ObjGraficiIncidenza.ObjGraficoX.AsseX = AsseXIncidenza        
        Self.ObjGraficiIncidenza.ObjGraficoY.AsseX = AsseXIncidenza
        Self.ObjGraficiIncidenza.ObjGraficoZ.AsseX = AsseXIncidenza

        Self.ObjGraficiIncidenza.ObjGraficoX.Generale.MinData = MinData        
        Self.ObjGraficiIncidenza.ObjGraficoY.Generale.MinData = MinData
        Self.ObjGraficiIncidenza.ObjGraficoZ.Generale.MinData = MinData
        Self.ObjGraficiIncidenza.ObjGraficoX.Generale.MaxData = MaxData        
        Self.ObjGraficiIncidenza.ObjGraficoY.Generale.MaxData = MaxData
        Self.ObjGraficiIncidenza.ObjGraficoZ.Generale.MaxData = MaxData

        Self.ObjGraficiAmpiezza.ObjGraficoX.Generale.Grafici = []
        Self.ObjGraficiAmpiezza.ObjGraficoY.Generale.Grafici = []
        Self.ObjGraficiAmpiezza.ObjGraficoZ.Generale.Grafici = []

        Self.ObjGraficiRitardo.ObjGraficoX.Generale.Punti = []
        Self.ObjGraficiRitardo.ObjGraficoY.Generale.Punti = []
        Self.ObjGraficiRitardo.ObjGraficoZ.Generale.Punti = []
        
        Self.Evento.Moduli.forEach((Modulo) =>
        {
          Self.ObjGraficiAmpiezza.ObjGraficoX.Generale.Grafici.push({Modulo : Modulo.Modulo, Profondita : Modulo.Profondita, Min : Modulo.MinX, Max : Modulo.MaxX})
          Self.ObjGraficiAmpiezza.ObjGraficoY.Generale.Grafici.push({Modulo : Modulo.Modulo, Profondita : Modulo.Profondita, Min : Modulo.MinY, Max : Modulo.MaxY})
          Self.ObjGraficiAmpiezza.ObjGraficoZ.Generale.Grafici.push({Modulo : Modulo.Modulo, Profondita : Modulo.Profondita, Min : Modulo.MinZ, Max : Modulo.MaxZ})
          if (Modulo.IstanteX != null)
            Self.ObjGraficiIncidenza.ObjGraficoX.Generale.Punti.push(Modulo.IstanteX)
          if (Modulo.IstanteY != null)
            Self.ObjGraficiIncidenza.ObjGraficoY.Generale.Punti.push(Modulo.IstanteY)
          if (Modulo.IstanteZ != null)
            Self.ObjGraficiIncidenza.ObjGraficoZ.Generale.Punti.push(Modulo.IstanteZ)
          
          Self.ObjGraficiRitardo.ObjGraficoX.Generale.Punti.push({Modulo : Modulo.Modulo, Profondita : Modulo.Profondita, Istante: Modulo.IstanteX})
          Self.ObjGraficiRitardo.ObjGraficoY.Generale.Punti.push({Modulo : Modulo.Modulo, Profondita : Modulo.Profondita, Istante: Modulo.IstanteY})
          Self.ObjGraficiRitardo.ObjGraficoZ.Generale.Punti.push({Modulo : Modulo.Modulo, Profondita : Modulo.Profondita, Istante: Modulo.IstanteZ})
        })
        Self.Mostra = true
        Self.CaricamentoDatiModuli = false
      },
      function(ErrorMessage,DescrErrore)
      {
        Self.CaricamentoDatiModuli = false
        alert(ErrorMessage + '[' + DescrErrore + ']')
      })
    },

    CalcoloBarraDiProgressione(LunghezzaArray, index)
    {
      if(LunghezzaArray != 0)
      {
        let PercentualePerIndex = 100 / LunghezzaArray
        this.OggettoModalCaricamentoDati.Width       = PercentualePerIndex * index
        this.OggettoModalCaricamentoDati.DatoPassato = true
      }
      else 
      {
        this.OggettoModalCaricamentoDati.Width       = 0.01
        this.OggettoModalCaricamentoDati.DatoPassato = true
      }
    },

    ApriPopupDatiSintetici()
    {
      this.PopupSintetici = true
    },

    ChiudiPopupSintetici()
    {
      this.PopupSintetici = false
    },

    ChiudiPopupLegenda()
    {
      this.PopupLegenda = false
    },

    CalcolaGrandezzaDivCanvas()
    {
      this.GrandezzaCanvasAmpiezza.Width = this.$refs.DivGraphAmpiezza.clientWidth / 3
      this.GrandezzaCanvasAmpiezza.Height = this.AltezzaPagina - 180
      this.GrandezzaCanvasIncidenza.Width  = this.$refs.DivIncidenza.clientWidth 
      this.GrandezzaCanvasIncidenza.Height = (this.AltezzaPagina - 325) / 3
      this.Repaint++ // this.$refs.DivButtons.clientHeight
    },

    AdattaAll()
    {
      this.ObjGraficoX.AxisY.Min = 99999
      this.ObjGraficoX.AxisY.Max = -99999
      this.ObjGraficoY.AxisY.Min = 99999
      this.ObjGraficoY.AxisY.Max = -99999
      this.ObjGraficoZ.AxisY.Min = 99999
      this.ObjGraficoZ.AxisY.Max = -99999

      this.PrimoCampione.X = 0
      this.PrimoCampione.Y = 0
      this.PrimoCampione.Z = 0

      for (let i = 0; i < this.Evento.Campioni.length; i++)
      {
        let SingoloCampione = this.Evento.Campioni[i] 
        if (i == 0 && this.Relativo)
        {
          this.PrimoCampione.X = SingoloCampione.X
          this.PrimoCampione.Y = SingoloCampione.Y
          this.PrimoCampione.Z = SingoloCampione.Z
        }
        if (this.ObjGraficoX.AxisY.Min > (SingoloCampione.X - this.PrimoCampione.X))
          this.ObjGraficoX.AxisY.Min = (SingoloCampione.X - this.PrimoCampione.X)
        if (this.ObjGraficoX.AxisY.Max < (SingoloCampione.X - this.PrimoCampione.X))
          this.ObjGraficoX.AxisY.Max = (SingoloCampione.X - this.PrimoCampione.X)
        if (this.ObjGraficoY.AxisY.Min > (SingoloCampione.Y - this.PrimoCampione.Y)) 
          this.ObjGraficoY.AxisY.Min = (SingoloCampione.Y - this.PrimoCampione.Y)
        if (this.ObjGraficoY.AxisY.Max < (SingoloCampione.Y - this.PrimoCampione.Y))
          this.ObjGraficoY.AxisY.Max = (SingoloCampione.Y - this.PrimoCampione.Y)
        if (this.ObjGraficoZ.AxisY.Min > (SingoloCampione.Z - this.PrimoCampione.Z))
          this.ObjGraficoZ.AxisY.Min = (SingoloCampione.Z - this.PrimoCampione.Z)
        if (this.ObjGraficoZ.AxisY.Max < (SingoloCampione.Z - this.PrimoCampione.Z))
          this.ObjGraficoZ.AxisY.Max = (SingoloCampione.Z - this.PrimoCampione.Z)
      }

      this.ObjGraficoX.AxisY.Udm = TZMathFunct.GetMultiplo((this.ObjGraficoX.AxisY.Max - this.ObjGraficoX.AxisY.Min) / 5, 5, 'PiuVicino')
      this.ObjGraficoY.AxisY.Udm = TZMathFunct.GetMultiplo((this.ObjGraficoY.AxisY.Max - this.ObjGraficoY.AxisY.Min) / 5, 5, 'PiuVicino')
      this.ObjGraficoZ.AxisY.Udm = TZMathFunct.GetMultiplo((this.ObjGraficoZ.AxisY.Max - this.ObjGraficoZ.AxisY.Min) / 5, 5, 'PiuVicino')

      this.ObjGraficoX.AxisY.Min = this.ObjGraficoX.AxisY.Min - Math.abs(this.ObjGraficoX.AxisY.Udm * 0.05)
      this.ObjGraficoY.AxisY.Min = this.ObjGraficoY.AxisY.Min - Math.abs(this.ObjGraficoY.AxisY.Udm * 0.05)
      this.ObjGraficoZ.AxisY.Min = this.ObjGraficoZ.AxisY.Min - Math.abs(this.ObjGraficoZ.AxisY.Udm * 0.05)
      this.ObjGraficoX.AxisY.Max = this.ObjGraficoX.AxisY.Max + Math.abs(this.ObjGraficoX.AxisY.Udm * 0.05)
      this.ObjGraficoY.AxisY.Max = this.ObjGraficoY.AxisY.Max + Math.abs(this.ObjGraficoY.AxisY.Udm * 0.05)
      this.ObjGraficoZ.AxisY.Max = this.ObjGraficoZ.AxisY.Max + Math.abs(this.ObjGraficoZ.AxisY.Udm * 0.05)

      if (this.ObjGraficoX.AxisY.Udm == 0)
        this.ObjGraficoX.AxisY.Udm = 1
      if (this.ObjGraficoY.AxisY.Udm == 0)
        this.ObjGraficoY.AxisY.Udm = 1
      if (this.ObjGraficoZ.AxisY.Udm == 0)
        this.ObjGraficoZ.AxisY.Udm = 1

      this.RepaintDeep++
    },

    ApriPopupImpostazioniAssi(Asse)
    {
      this.ObjPopupImpostazioniAssi.TipoAsse   = Asse
      let AxisPopup                            = {}
      AxisPopup.Max                            = 0
      AxisPopup.Min                            = 0
      AxisPopup.Udm                            = 0
      switch (Asse)
      {
        case this.TipiAssi.X :
        {
          AxisPopup.Max = this.ObjGraficoX.AxisY.Max
          AxisPopup.Min = this.ObjGraficoX.AxisY.Min
          AxisPopup.Udm = this.ObjGraficoX.AxisY.Udm
          break
        }
        case this.TipiAssi.Y :
        {
          AxisPopup.Max = this.ObjGraficoY.AxisY.Max
          AxisPopup.Min = this.ObjGraficoY.AxisY.Min
          AxisPopup.Udm = this.ObjGraficoY.AxisY.Udm
          break
        }
        case this.TipiAssi.Z :
        {
          AxisPopup.Max = this.ObjGraficoZ.AxisY.Max
          AxisPopup.Min = this.ObjGraficoZ.AxisY.Min
          AxisPopup.Udm = this.ObjGraficoZ.AxisY.Udm
          break
        }
        case this.TipiAssi.Tutte :
        {
          AxisPopup.Max = 5
          AxisPopup.Min = -5
          AxisPopup.Udm = 2
          break
        }
      }
      this.ObjPopupImpostazioniAssi.Axis = AxisPopup
      this.PopupImpostazioniAssi = true
    },

    ConfermaPopupAssi()
    {
      switch (this.ObjPopupImpostazioniAssi.TipoAsse)
      {
        case this.TipiAssi.X :
        {
          this.ObjGraficoX.AxisY.Max = this.ObjPopupImpostazioniAssi.Axis.Max
          this.ObjGraficoX.AxisY.Min = this.ObjPopupImpostazioniAssi.Axis.Min 
          this.ObjGraficoX.AxisY.Udm = this.ObjPopupImpostazioniAssi.Axis.Udm
          break
        }
        case this.TipiAssi.Y :
        {
          this.ObjGraficoY.AxisY.Max = this.ObjPopupImpostazioniAssi.Axis.Max
          this.ObjGraficoY.AxisY.Min = this.ObjPopupImpostazioniAssi.Axis.Min
          this.ObjGraficoY.AxisY.Udm = this.ObjPopupImpostazioniAssi.Axis.Udm
          break
        }
        case this.TipiAssi.Z :
        {
          this.ObjGraficoZ.AxisY.Max = this.ObjPopupImpostazioniAssi.Axis.Max
          this.ObjGraficoZ.AxisY.Min = this.ObjPopupImpostazioniAssi.Axis.Min
          this.ObjGraficoZ.AxisY.Udm = this.ObjPopupImpostazioniAssi.Axis.Udm
          break
        }
        case this.TipiAssi.Tutte :
        { 
          this.ObjGraficoX.AxisY.Max = this.ObjPopupImpostazioniAssi.Axis.Max
          this.ObjGraficoX.AxisY.Min = this.ObjPopupImpostazioniAssi.Axis.Min 
          this.ObjGraficoX.AxisY.Udm = this.ObjPopupImpostazioniAssi.Axis.Udm
          this.ObjGraficoY.AxisY.Max = this.ObjPopupImpostazioniAssi.Axis.Max
          this.ObjGraficoY.AxisY.Min = this.ObjPopupImpostazioniAssi.Axis.Min
          this.ObjGraficoY.AxisY.Udm = this.ObjPopupImpostazioniAssi.Axis.Udm
          this.ObjGraficoZ.AxisY.Max = this.ObjPopupImpostazioniAssi.Axis.Max
          this.ObjGraficoZ.AxisY.Min = this.ObjPopupImpostazioniAssi.Axis.Min
          this.ObjGraficoZ.AxisY.Udm = this.ObjPopupImpostazioniAssi.Axis.Udm          
          break
        }
      }
      this.Repaint++
      this.PopupImpostazioniAssi = false
    },

    AnnullaPopupAssi()
    {
      this.PopupImpostazioniAssi = false
    },
    
    GetInfoCatena(OnSuccess = null)
    {
      this.Catena.Info = {}
      let Self = this
      this.DatiURL = TZGenericFunct.GetURLParameters()
      SystemInformation.AdvQuerySiti.SessionId = SystemInformation.AdvQuery.SessionId
      SystemInformation.AdvQuerySiti.GetSQL("Catene",{Chiave : this.DatiURL.Catena, DMSEWSito : this.DatiURL.Sito},
                                              function(Results)
                                              {
                                                let MinProfondita = 999
                                                let MaxProfondita = 0
                                                let ArrayInfo   = SystemInformation.AdvQuerySiti.FindResults(Results,"SelectInfo");
                                                let ArrayModuli = SystemInformation.AdvQuerySiti.FindResults(Results,"SelectInfoModuli");
                                                if(ArrayInfo != undefined)
                                                {
                                                  let Info = ArrayInfo[0]
                                                  Self.Catena.Info.Descrizione            = TSchedaGenerica.DisponiFromString(Info.DESCRIZIONE)
                                                  Self.Catena.Info.Cliente                = TSchedaGenerica.DisponiFromString('Non presente')
                                                  Self.Catena.Info.NomeSito               = TSchedaGenerica.DisponiFromString(Info.SITO)
                                                  Self.Catena.Info.Progetto               = TSchedaGenerica.DisponiFromString(Info.PROGETTO)
                                                  Self.Catena.Info.IntervalloMonitoraggio = TSchedaGenerica.DisponiFromString(Info.MONITORAGGIO)
                                                  Self.Catena.Info.DataCalibrazione       = TSchedaGenerica.DisponiFromDate(Info.DATA_INSTALLAZIONE)
                                                  Self.Catena.Info.DataInstallazione      = TSchedaGenerica.DisponiFromDate(Info.DATA_CALIRAZIONE)
                                                  Self.Catena.Info.Note                   = TSchedaGenerica.DisponiFromString(Info.NOTE)
                                                  Self.Catena.Moduli                      = ArrayModuli
                                                  ArrayModuli.forEach((element) =>
                                                  {
                                                    if (element.PROFONDITA / 100 > MaxProfondita)
                                                      MaxProfondita = element.PROFONDITA / 100
                                                    if (element.PROFONDITA / 100 < MinProfondita)
                                                      MinProfondita = element.PROFONDITA / 100
                                                  })
                                                  let AxisYAmpiezza = {}
                                                  AxisYAmpiezza.Min = MinProfondita
                                                  AxisYAmpiezza.Max = MaxProfondita
                                                  AxisYAmpiezza.Udm = 10
                                                  Self.ObjGraficiAmpiezza.ObjGraficoX.AsseY    = AxisYAmpiezza
                                                  Self.ObjGraficiAmpiezza.ObjGraficoY.AsseY    = AxisYAmpiezza
                                                  Self.ObjGraficiAmpiezza.ObjGraficoZ.AsseY    = AxisYAmpiezza              
                                                  
                                                  Self.ObjGraficiRitardo.ObjGraficoX.AsseY     = AxisYAmpiezza
                                                  Self.ObjGraficiRitardo.ObjGraficoY.AsseY     = AxisYAmpiezza
                                                  Self.ObjGraficiRitardo.ObjGraficoZ.AsseY     = AxisYAmpiezza
                                                }
                                                else SystemInformation.HandleError("Impossibile ottenere i dati della catena");
                                                Self.InfoCatena = true
                                                if(OnSuccess != null)
                                                  OnSuccess()
                                              },
                                              function(HTTPError,SubHTTPError)
                                              {
                                                SystemInformation.HandleError(HTTPError,SubHTTPError)
                                              }, 'SelectAllDatiCatena');
    },

    GetStartConfig()
    {
      let AxisYIncidenza = {}
      AxisYIncidenza.Max = 10
      AxisYIncidenza.Min = 0
      AxisYIncidenza.Udm = 2

      this.ObjGraficiAmpiezza  = new TObjGruppoGrafici()
      this.ObjGraficiRitardo   = new TObjGruppoGrafici()
      this.ObjGraficiIncidenza = new TObjGruppoGrafici()

      this.ObjGraficiIncidenza.ObjGraficoX.AsseY   = AxisYIncidenza
      this.ObjGraficiIncidenza.ObjGraficoY.AsseY   = AxisYIncidenza
      this.ObjGraficiIncidenza.ObjGraficoZ.AsseY   = AxisYIncidenza

      this.GetInfoCatena(this.CaricaDati)
      // this.CaricaDati()
    }
  },
  
  computed:
  {

  },
  
  watch:
  {
    GraficiChange:
    {
      handler()
      {
        this.RepaintDeep++
      }
    },
  },

  beforeMount()
  {
    this.GetStartConfig()
    // this.ChangeRelativo()
    // if (!this.EventiSovrapposti)
    // {
    //   this.TitoloFrame = 'Superamento soglia del ' + this.Evento.DataEffettiva + ' Modulo nr. ' + this.Evento.Modulo + ' - Profondità: ' + this.Evento.Profondita.toFixed(2) + ' mpc'
    // }
    // else
    // {
    //   if (this.Evento.length == 1)
    //   {
    //     this.TitoloFrame = 'Superamento soglia del ' + this.Evento[0].DataEffettiva + ' Modulo nr. ' + this.Evento[0].Modulo + ' - Profondità: ' + this.Evento[0].Profondita.toFixed(2) + ' mpc'
    //   }
    //   else
    //   {
    //     let MinProfondita = 9999
    //     let MaxProfondita = -9999
    //     this.Evento.forEach((element) => 
    //     {
    //       MinProfondita = Math.min(MinProfondita, element.Profondita)
    //       MaxProfondita = Math.max(MaxProfondita, element.Profondita)
    //     })
    //     this.TitoloFrame = 'Superamenti soglia sovrapposti - Profondità da ' + MinProfondita.toFixed(2) + ' a ' + MaxProfondita.toFixed(2) + ' mpc'
    //   }
    // }
  },
  mounted()
  {
    this.CalcolaGrandezzaDivCanvas()
    window.addEventListener('resize', this.CalcolaGrandezzaDivCanvas)
  },
  beforeUnmount()
  {
    window.removeEventListener('resize', this.CalcolaGrandezzaDivCanvas)
  }
}
</script>